import config from "config/config";
import { useRouter } from "next/router";
import { Chakra } from "@airhelp/react-ui-components";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { useForm } from "react-hook-form";
import { Input } from "components/FormControl";

const { Button, Stack } = Chakra;

const SearchBar = () => {
  const router = useRouter();
  const language = useLanguage();
  const translations = useTranslations();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<{ searchQuery: string }>({ defaultValues: { searchQuery: "" } });

  const onSubmit = ({ searchQuery }: { searchQuery: string }) =>
    router.push(`${config.websiteUrl}/${language}/help/search?search=${searchQuery}`);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack
        pt={6}
        direction={{ base: "column", lg: "row" }}
        spacing={3}
        w={{ base: "100vw", md: "60vw", lg: "40vw" }}
        px={4}
        mx="auto"
      >
        <Input
          name="searchQuery"
          errors={errors}
          register={register({ required: true, minLength: 3 })}
          placeholder={translations("search_for_answer")}
        />
        <Button px={6} type="submit">
          {translations("search")}
        </Button>
      </Stack>
    </form>
  );
};

export default SearchBar;
